import { SettingsConfig } from '@core/utils/config';

export function isMultiCurrencyEnabled() {
  return SettingsConfig.current()?.isMulticurrency || false;
}

export function isMultiCurrency<T>(enabled: () => T, notEnabled: () => T) {
  return isMultiCurrencyEnabled() ? enabled() : notEnabled();
}
